import * as types from '../mutation-types'
import localforage from 'localforage'

export default store => {
  store.subscribe(async mutation => {
    switch (mutation.type) {
      case types.SET_FONT_SIZE:
      case types.SET_MARGIN:
      case types.SET_PRE_ORDER_RING:
      case types.SET_NEW_ORDER_RING:
        await localforage.setItem('settings', JSON.stringify(store.state.settings))
        break
      default:
    }
  })
}
